export default __webpack_public_path__ + "static/media/B25.f17f79ed.png";